export enum ButtonFrame {
	Up,
	Over,
	Down,
	Disabled
}